import React, { useState } from "react";
import QueryForm from "./queryform";

const Cta = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <section id="cta">
        <div className="cta-box">
          <h2>Let’s Build Something Great Together</h2>
          <p>
            Have an idea or a project in mind? Partner with Infobizz to create
            scalable, secure, and high-performance digital solutions.
          </p>

          <button className="cta-btn" onClick={() => setOpen(true)}>
            Get Started Today
          </button>
        </div>
      </section>

      {open && <QueryForm onClose={() => setOpen(false)} />}
    </>
  );
};

export default Cta;
